<script lang="ts">
    import SortMenuAccessory from '@amp/web-app-components/src/components/Accessory/SortMenu.svelte';
    import { getI18n } from '~/stores/i18n';
    import { getJetPerform } from '~/jet';
    import { makeInvalidationAction } from '@jet-app/music-classical/action-model/InvalidationAction';
    import type { SortAccessoryButton } from '@jet-app/music-classical/models/section/AccessoryButton';

    export let config: SortAccessoryButton;

    const i18n = getI18n();
    const perform = getJetPerform();

    const handleSortByChange = (e) => {
        perform(
            makeInvalidationAction({
                kind: 'sortByChanged',
                metadata: e.detail,
            }),
        );
    };
</script>

<SortMenuAccessory
    ariaLabel={$i18n.t('ASE.Web.MusicClassical.Sort')}
    {config}
    translateFn={$i18n.t}
    on:sortByChange={handleSortByChange}
/>
